import { format } from 'date-fns';
import { useDispatch } from 'react-redux';
import useForm from '../../../../lib/hooks/useForm';
import { api } from '../../../../lib/api';
import { closeCalendar } from '../../../../lib/redux/campaignCalendar/campaignCalendarSlice';
import { useCampaignMutation } from '../useCampaignMutation';

const mutationFn = values => {
  const { uuid, startDate, endDate } = values;

  return api.patch(`/api/client_admin/campaigns/${uuid}`, {
    campaign: {
      start_date: startDate,
      end_date: endDate,
    },
  });
};

export const useDateForm = ({ startDate, endDate, id }) => {
  const dispatch = useDispatch();
  const { mutate } = useCampaignMutation({
    mutationFn,
    onSuccess: () => dispatch(closeCalendar()),
  });
  const initialValues = {
    uuid: id,
    startDate: startDate || '',
    endDate: endDate || '',
  };

  const form = useForm({
    initialValues,
    enableReinitialize: true,
  });

  const handleDateUpdate = dates => {
    const newStartDate = format(dates[0], 'yyyy-MM-dd');
    const newEndDate = dates[1] ? format(dates[1], 'yyyy-MM-dd') : null;

    form.setFieldValue('startDate', newStartDate);
    form.setFieldValue('endDate', newEndDate);

    if (dates[0] && dates[1]) {
      mutate({ uuid: id, startDate: newStartDate, endDate: newEndDate });
    }
  };

  return { ...form, handleDateUpdate };
};
